import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {UserPermissionsService} from '../services/user-permissions.service';

export const conditionMapRightsAndRoutes = {
    criterion: '/criterion',
    department: '/department',
    facility: '/facility',
    indexentity: '/index-entity',
    indexiasvalue: '/index-ias',
    indicator: '/indicators',
    landmark: '/landmarks',
    org_group: '/group',
    ref_organization: '/organization',
    useraccount: '/users',
    grade: '/grade',
    create: '/grade/create',
    analytics: '/report-general'
} as Record<keyof AccessToGuides | 'create', string>

export const viewGuard = (page: keyof AccessToGuides | 'create'): CanActivateFn => () => {
    const permissionsService = inject(UserPermissionsService);
    const router = inject(Router)

    if (page === 'create' && permissionsService.permissons$.value?.create?.grade) return true;

    if ((permissionsService.permissons$.value?.view as Record<keyof AccessToGuides | 'create', boolean>)?.[page]) {
        return true;
    } else {
        const anables = Object.entries(permissionsService.permissons$.value?.view || {})
            .filter(([key, value]) => !!value);
        if (anables.length) {
            router.navigate([conditionMapRightsAndRoutes[anables[0][0] as keyof AccessToGuides]]);
        } else {
            router.navigate(['/login']);
        }
        return false;
    }
};
